import { Component, OnInit } from '@angular/core'
import { BaseListing } from '../_base-listing/base-listing'
import { ListingItem } from 'depoto-core/src/models'
import { institutionsColumns } from '../../utils/definitions.util'
import { CoreService } from '../../services'
import { Institution } from 'depoto-core/src/entities/Institution'

const DEFAULT_FILTERS = {
  visible: false,
  expanded: false,
  name: '',
  sortProp: 'name',
  sortDir: 'asc',
}

@Component({
  selector: 'app-institutions',
  templateUrl: './institutions.component.html',
  styleUrls: ['./institutions.component.scss'],
})
export class InstitutionsComponent extends BaseListing implements OnInit {
  listingColumns: ListingItem[] = institutionsColumns
  institutions: Institution[] = []
  totalItems = 0
  currentPage: number
  endPage: number
  filters = DEFAULT_FILTERS
  canCreate = false
  loading = true
  constructor(protected core: CoreService) {
    super(core)
    this.getStorageKey('institutions')
  }

  ngOnInit() {
    this.filters = this.loadViewSettings('institutions') || DEFAULT_FILTERS
    if (this.core.services.user.user) {
      this.checkPerms()
    }
    this.core.services.user.currentUserEmitter.subscribe().then(() => {
      this.checkPerms()
    })
    this.filter()
  }

  checkPerms() {
    this.canCreate =
      this.core.services.user.hasRole('ROLE_SUPER_ADMIN') ||
      this.core.services.user.hasRole('ROLE_ADMIN') ||
      this.core.services.user.hasRole('ROLE_SUPER_ADMIN')
  }

  clearFilters(): void {
    this.filters.name = ''
    this.filter(1)
  }

  filter(pageNo = 1, sortProp: string = this.sortProp, sortDir: string = this.sortDir, concat = false): void {
    const options: any = {}
    this.currentPage = pageNo
    if (this.filters && this.filters.name && this.filters.name.length > 0) {
      options.name = this.filters.name
    }
    this.loading = true
    if (!concat) {
      this.reloading = true
    }
    this.core.services.institution
      .getList(
        { page: pageNo, sort: sortProp, direction: sortDir, filters: options },
        {
          id: null,
          name: null,
          company: { id: null },
        },
      )
      .then(result => {
        this.loading = false
        this.reloading = false
        if (!concat) {
          this.institutions = result.items
        } else {
          result.items.forEach(institution => {
            this.institutions.push(new Institution(institution))
          })
        }
        this.totalItems = result.paginator ? result.paginator.totalCount : 0
        this.endPage = result.paginator ? result.paginator.endPage : 0
        this.saveViewSettings('institutions', this.filters)
      })
    this.loading = false
  }
}
